/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetMarketsGroupsMarketGroupIdOk
 */
export interface GetMarketsGroupsMarketGroupIdOk {
    /**
     * description string
     * @type {string}
     * @memberof GetMarketsGroupsMarketGroupIdOk
     */
    description: string;
    /**
     * market_group_id integer
     * @type {number}
     * @memberof GetMarketsGroupsMarketGroupIdOk
     */
    marketGroupId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetMarketsGroupsMarketGroupIdOk
     */
    name: string;
    /**
     * parent_group_id integer
     * @type {number}
     * @memberof GetMarketsGroupsMarketGroupIdOk
     */
    parentGroupId?: number;
    /**
     * types array
     * @type {Array<number>}
     * @memberof GetMarketsGroupsMarketGroupIdOk
     */
    types: Array<number>;
}

/**
 * Check if a given object implements the GetMarketsGroupsMarketGroupIdOk interface.
 */
export function instanceOfGetMarketsGroupsMarketGroupIdOk(value: object): value is GetMarketsGroupsMarketGroupIdOk {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('marketGroupId' in value) || value['marketGroupId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('types' in value) || value['types'] === undefined) return false;
    return true;
}

export function GetMarketsGroupsMarketGroupIdOkFromJSON(json: any): GetMarketsGroupsMarketGroupIdOk {
    return GetMarketsGroupsMarketGroupIdOkFromJSONTyped(json, false);
}

export function GetMarketsGroupsMarketGroupIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsGroupsMarketGroupIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'marketGroupId': json['market_group_id'],
        'name': json['name'],
        'parentGroupId': json['parent_group_id'] == null ? undefined : json['parent_group_id'],
        'types': json['types'],
    };
}

export function GetMarketsGroupsMarketGroupIdOkToJSON(json: any): GetMarketsGroupsMarketGroupIdOk {
    return GetMarketsGroupsMarketGroupIdOkToJSONTyped(json, false);
}

export function GetMarketsGroupsMarketGroupIdOkToJSONTyped(value?: GetMarketsGroupsMarketGroupIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'market_group_id': value['marketGroupId'],
        'name': value['name'],
        'parent_group_id': value['parentGroupId'],
        'types': value['types'],
    };
}

